import { NavLink } from 'react-router-dom';
import { Home, UserPlus, FileText } from 'lucide-react';
import { useAuth } from '../helpers/useAuth';

const Sidebar = ({ sidebarOpen }) => {
  const { isLoggedIn } = useAuth();

  // Don't render sidebar if not logged in
  if (!isLoggedIn) {
    return null;
  }

  return (
    <div 
      className={`h-full flex flex-col shadow-xl transition-all duration-300 ease-in-out ${
        sidebarOpen ? 'w-64' : 'w-20'
      }`}
      style={{ background: 'linear-gradient(to bottom, #3b1a6b, #4e2280, #5B2D8E)' }}
    >
      {/* Header Section - Compact for collapsed mode */}
      <div className="p-5 border-b" style={{ borderColor: 'rgba(255,255,255,0.15)' }}>
        {sidebarOpen ? (
          <>
            <div className="flex items-center gap-3"></div>
            <h1 className="text-sm font-bold mt-3 leading-tight" style={{ color: '#f5d87a' }}>
              GH RAISONI ADMISSIONS CRM
            </h1>
            <p className="text-xs mt-1" style={{ color: 'rgba(255,255,255,0.6)' }}>
              Management System
            </p>
          </>
        ) : (
          <div className="flex justify-center">
            <div className="w-8 h-8 rounded-full bg-white/10 flex items-center justify-center">
              <span className="text-xs font-bold" style={{ color: '#f5d87a' }}>GR</span>
            </div>
          </div>
        )}
      </div>

      {/* Navigation */}
      <nav className="flex-1 p-4 overflow-y-auto">
        <ul className="space-y-1">
          <li>
            <NavLink
              to="/"
              end
              className={({ isActive }) =>
                `flex items-center gap-3 p-3 rounded-lg transition-all duration-200 ${
                  !sidebarOpen ? 'justify-center' : ''
                }`
              }
              style={({ isActive }) => ({
                backgroundColor: isActive ? 'rgba(245, 216, 122, 0.25)' : 'transparent',
                color: isActive ? '#f5d87a' : 'rgba(255,255,255,0.85)',
                borderLeft: isActive ? '3px solid #f5d87a' : '3px solid transparent',
              })}
            >
              <Home size={20} />
              {sidebarOpen && <span className="font-medium">Dashboard</span>}
            </NavLink>
          </li>

          <li>
            <NavLink
              to="/student-registration"
              className={({ isActive }) =>
                `flex items-center gap-3 p-3 rounded-lg transition-all duration-200 ${
                  !sidebarOpen ? 'justify-center' : ''
                }`
              }
              style={({ isActive }) => ({
                backgroundColor: isActive ? 'rgba(245, 216, 122, 0.25)' : 'transparent',
                color: isActive ? '#f5d87a' : 'rgba(255,255,255,0.85)',
                borderLeft: isActive ? '3px solid #f5d87a' : '3px solid transparent',
              })}
            >
              <UserPlus size={20} />
              {sidebarOpen && <span className="font-medium">Student Registration</span>}
            </NavLink>
          </li>

          <li>
            <NavLink
              to="/student-report"
              className={({ isActive }) =>
                `flex items-center gap-3 p-3 rounded-lg transition-all duration-200 ${
                  !sidebarOpen ? 'justify-center' : ''
                }`
              }
              style={({ isActive }) => ({
                backgroundColor: isActive ? 'rgba(245, 216, 122, 0.25)' : 'transparent',
                color: isActive ? '#f5d87a' : 'rgba(255,255,255,0.85)',
                borderLeft: isActive ? '3px solid #f5d87a' : '3px solid transparent',
              })}
            >
              <FileText size={20} />
              {sidebarOpen && <span className="font-medium">Student Reports</span>}
            </NavLink>
          </li>
        </ul>
      </nav>

      {/* Footer */}
      <div className="p-4 border-t text-center" style={{ borderColor: 'rgba(255,255,255,0.15)' }}>
        {sidebarOpen ? (
          <p className="text-xs" style={{ color: 'rgba(255,255,255,0.5)' }}>
            Admissions Portal
          </p>
        ) : (
          <div className="w-6 h-6 mx-auto rounded-full bg-white/5"></div>
        )}
      </div>
    </div>
  );
};

export default Sidebar;